import initialState from '../../../../store/initialState';
import * as types from '../services/strategicCapsVsDemandActionType';

export default function strategicCapsVsDemandReducer(state = initialState.strategicCapsVsDemandReducer, action) {
    switch (action.type) {
        case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST:
            return {
                ...state, capsDemandFilterByIdLoading: true, capsDemandFilterByIdError: null
            };
        case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_SUCCESS:
            return {
                ...state, capsDemandFilterById: action.payload, capsDemandFilterByIdLoading: false, capsDemandFilterByIdError: null
            };
        case types.FETCH_CAPS_DEMAND_FILTER_BY_ID_FAILURE:
            return {
                ...state, capsDemandFilterByIdLoading: false, capsDemandFilterByIdError: action.payload
            };
        default:
            return state;
    }
}
